import { type PropsWithChildren } from "react";

export function TableBody(props: PropsWithChildren) {
  return <div className="table w-full">{props.children}</div>;
}
